import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  public currLat = 0;
  public currLng = 0;

  constructor() { }
  getCurrentLocation() {
    const location = [];
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.currLat = position.coords.latitude;
        this.currLng = position.coords.longitude;
        //console.log('serv pos: ', position.coords.latitude);
        location.push(this.currLat , this.currLng);
      });
    }
    else {
      alert("Geolocation is not supported by this browser.");
    }
    return location;
  }
}
